import PropTypes from 'prop-types'

export default {
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    phone_primary: PropTypes.string.isRequired,
    phone_secondary: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    postcode: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    country_code: PropTypes.string.isRequired,
    coordinates: PropTypes.arrayOf(PropTypes.number).isRequired,
    devices: PropTypes.arrayOf(
        PropTypes.shape({
            last_contact: PropTypes.number,
            last_download: PropTypes.number,
            store_location: PropTypes.oneOfType([
                PropTypes.number,
                PropTypes.shape({
                    slug: PropTypes.string,
                    name: PropTypes.string,
                }),
            ]),
        })
    ),
}
